import Schema from "@/store/modules/fuelCards/schema";
import BaseActions from '@/store/base/actions'

const module = 'fuelCards'

export default BaseActions({module}, {
	//
}, [Schema])
